import { QPRECO_LEVELS } from '../../constants';

export const QPRECO_LEVEL_ORDER = [
  QPRECO_LEVELS.VERY_HIGH,
  QPRECO_LEVELS.HIGH,
  QPRECO_LEVELS.GOOD,
  QPRECO_LEVELS.IDEAL,
  QPRECO_LEVELS.GREAT,
];

export const QPRECO_LEVEL_CONFIG = {
  [QPRECO_LEVELS.VERY_HIGH]: {
    id: QPRECO_LEVELS.VERY_HIGH,
    translationKey: 'QPrecoVeryHigh',
    variant: 'critical',
  },
  [QPRECO_LEVELS.HIGH]: {
    id: QPRECO_LEVELS.HIGH,
    translationKey: 'QPrecoHigh',
    variant: 'warning',
  },
  [QPRECO_LEVELS.GOOD]: {
    id: QPRECO_LEVELS.GOOD,
    translationKey: 'QPrecoGood',
    variant: 'positive',
  },
  [QPRECO_LEVELS.IDEAL]: {
    id: QPRECO_LEVELS.IDEAL,
    translationKey: 'QPrecoIdeal',
    variant: 'info',
  },
  [QPRECO_LEVELS.GREAT]: {
    id: QPRECO_LEVELS.GREAT,
    translationKey: 'QPrecoGreat',
    variant: 'infoGreat',
  },
};

const LEVEL_ALIASES = {
  1: QPRECO_LEVELS.VERY_HIGH,
  very_high: QPRECO_LEVELS.VERY_HIGH,
  muito_alto: QPRECO_LEVELS.VERY_HIGH,
  2: QPRECO_LEVELS.HIGH,
  high: QPRECO_LEVELS.HIGH,
  alto: QPRECO_LEVELS.HIGH,
  3: QPRECO_LEVELS.GOOD,
  good: QPRECO_LEVELS.GOOD,
  bom: QPRECO_LEVELS.GOOD,
  4: QPRECO_LEVELS.IDEAL,
  ideal: QPRECO_LEVELS.IDEAL,
  5: QPRECO_LEVELS.GREAT,
  great: QPRECO_LEVELS.GREAT,
  otimo: QPRECO_LEVELS.GREAT,
};

const normalizeLevelId = (id) => {
  if (!id) return null;
  return LEVEL_ALIASES[String(id).toLowerCase()] ?? null;
};

const getCountFromValue = (value) => {
  if (value == null) return 0;
  if (typeof value === 'object') return Number(value.count) || 0;
  return Number(value) || 0;
};

const getUrlFromValue = (value) => {
  if (value && typeof value === 'object') return value.redirect_url || null;
  return null;
};

export function formatQprecoCount(count, locale = 'es-AR') {
  const numericCount = Number(count) || 0;
  return numericCount.toLocaleString(locale);
}

export function mapQprecoLevels(payload = []) {
  const byId = {};

  if (Array.isArray(payload)) {
    payload.forEach((item) => {
      const id = normalizeLevelId(item?.price_id);
      if (!id) return;
      byId[id] = item;
    });
  } else if (payload && typeof payload === 'object') {
    Object.entries(payload).forEach(([key, value]) => {
      const id = normalizeLevelId(key);
      if (!id) return;
      byId[id] = value;
    });
  }

  return QPRECO_LEVEL_ORDER.map((id) => {
    const source = byId[id];
    return {
      ...QPRECO_LEVEL_CONFIG[id],
      count: getCountFromValue(source),
      url: getUrlFromValue(source) || source?.url || null,
    };
  });
}

export function isQprecoEmpty(levels = []) {
  if (!levels.length) return true;
  return levels.every((level) => Number(level.count) === 0);
}
